import { getApplicableTaxes } from '../components/Dashboard/Spaces/SpaceAction';
import {BOOKING_TYPE} from "../components/common/constants";

export const setValuesToFields = (spaceDetails, form, setActivityId, setCurrency, dispatchTax, spcCategory) => {
    const eventsData = spaceDetails?.events;
    setCurrency(getCurrencyByCountry(spaceDetails?.location?.country));
    
    if(spaceDetails?.location?.country) dispatchTax(spaceDetails?.location?.country);
    if(spcCategory === 'Work'){
      form.setFieldsValue({
          id: spaceDetails.id,
          platform: spaceDetails.platform,
          platformReference: spaceDetails.platformReference,
          spaceOwner: spaceDetails.spaceOwner,
          taxRegNo: spaceDetails.taxRegNo,
          notTaxRegistered: spaceDetails.taxRegNo? false : true,
          instanceBookingAvailability : spaceDetails?.instanceBookingAvailability === true ? BOOKING_TYPE[0].boolValue : BOOKING_TYPE[1].boolValue,
          spaceArea: spaceDetails.spaceArea,
          spaceName: spaceDetails.spaceName,
          organizationName: spaceDetails.organizationName,
          location: spaceDetails.location,
          nearMrtAvailability: spaceDetails?.nearMrtAvailability,
          parkingAvailability: spaceDetails?.parkingAvailability,
          nearByLocations: spaceDetails?.nearByLocations || [],
          description: spaceDetails.description,
          // maximumSeats: spaceDetails.seatArrangements ? spaceDetails.seatArrangements[0].max : eventsData ? spaceDetails.events[0].seatArrangements[0].max : null,
          category: eventsData? spaceDetails.events[0].eventType.spaceCategory.name : null,
          payout: spaceDetails.payout,
          eventId: eventsData ? spaceDetails.events[0].eventType.id : null,
          spaceCurrency: (getCurrencyByCountry(spaceDetails?.location?.country)),
        
          spaceStatus: spaceDetails.spaceStatus,
          noticePeriod: spaceDetails?.events?.[0]?.chargings?.[0]?.noticePeriod ? spaceDetails?.events?.[0]?.chargings?.[0]?.noticePeriod : 0,
          events: spaceDetails?.events?.map(event => {
              return {
                  eventType:{id: event.eventType?.id},
                  seatArrangements: event.seatArrangements?.map(seat => {return {max: seat.max}}),
                  cancellationPolicy: {id: event.cancellationPolicy.id},
                  amenities: event.amenities?.map(am => am.id),
                  spaceAddOns: event.spaceAddOns?.map(addOn => {return {
                      isAvailable: true,
                      id: addOn.addOn?.id,
                      charge: {
                          price: addOn.charge?.price?.amount
                      },
                      description: addOn.description
                  }}),
                  keepInMind: event.keepInMind?.map(k_mind => {return {
                      rule: {
                        id: k_mind.rule?.id
                      },
                      isDisabled: k_mind.isDisabled
                    }
                  }),
                  chargings: event.chargings?.map(charging => { return {
                      ...charging,
                      chargingType: {id: charging.chargingType?.id},
                      chargingTypeDesc: {name: charging.chargingType?.name},
                      amount: charging.pricingOptions[0].price.amount,
                      isDiscountVisible: charging.discounts ? true : false,
                      days: charging.pricingOptions?.map(p => p.name) || [],
                    }
                  }),
                  seatArrangements: event.seatArrangements
              }
          }),
          applicableTaxes: spaceDetails?.applicableTaxes?.map(tx => tx.id),
          images:  spaceDetails?.images && spaceDetails.images.length > 0 ? spaceDetails.images.map(img =>{return {
            url: img.url,
            publicId: img.publicId,
            etag: img.etag,
            signature: img.signature,
            isPrimary: img.isPrimary
          }
        }) : null
        });
        setActivityId(eventsData? spaceDetails.events[0].eventType.id : null);
      }else if (spcCategory === 'Meet' || spcCategory === 'Shoot'){
        form.setFieldsValue({
          ...spaceDetails,
          applicableTaxes: spaceDetails.applicableTaxes?.map(tx => tx.id),
          cancellationPolicy: {id: spaceDetails.cancellationPolicy?.id ? spaceDetails.cancellationPolicy?.id : eventsData? spaceDetails.events[0].cancellationPolicy?.id : null},
          notTaxRegistered: spaceDetails.taxRegNo? false : true,
          spaceOwner: spaceDetails.spaceOwner,
          payout: spaceDetails.payout,
          instanceBookingAvailability : spaceDetails?.instanceBookingAvailability === true ? BOOKING_TYPE[0].boolValue : BOOKING_TYPE[1].boolValue,
          maximumSeats: spaceDetails.seatArrangements ? spaceDetails.seatArrangements[0].max : eventsData ? spaceDetails.events[0].seatArrangements[0].max : null,
          category: spaceDetails.eventTypes ? spaceDetails.eventTypes[0].spaceCategory?.id : eventsData? spaceDetails.events[0].eventType.spaceCategory.name : null,
          eventId: spaceDetails.eventTypes?.map(e => e.id) ? spaceDetails.eventTypes?.map(e => e.id) : eventsData ? spaceDetails.events[0].eventType.id : null,
          amenities: spaceDetails.amenities?.map(am => am.id),
          eventTypes: spaceDetails.eventTypes ? spaceDetails.eventTypes.map(evnt => evnt.id) : null,
          spaceStatus: spaceDetails.spaceStatus,
          images:  spaceDetails?.images && spaceDetails.images.length > 0 ? spaceDetails.images.map(img =>{return {
              url: img.url,
              publicId: img.publicId,
              etag: img.etag,
              signature: img.signature,
              isPrimary: img.isPrimary
            }
          }) : eventsData ? spaceDetails?.events[0]?.images.map(img =>{return {
            url: img.url,
            publicId: img.publicId,
            etag: img.etag,
            signature: img.signature,
            isPrimary: img.isPrimary
          }
        }) : null,
          spaceCurrency: spaceDetails?.location?.country ? (getCurrencyByCountry(spaceDetails?.location?.country)) : (getCurrencyByCountry(eventsData? spaceDetails?.events[0]?.location?.country : null)),
          pricingOption: spaceDetails?.chargings !== null &&  spaceDetails?.chargings ? spaceDetails.chargings.map(charge => charge.chargingType.id): eventsData ? spaceDetails.events[0].chargings.map(charge => charge.chargingType.id) : null,
          noticePeriod: spaceDetails?.chargings?.[0]?.noticePeriod ? spaceDetails?.chargings?.[0]?.noticePeriod : eventsData ? spaceDetails.events[0].chargings?.[0]?.noticePeriod : null,
            chargings: spaceDetails?.chargings !== null &&  spaceDetails?.chargings ? spaceDetails.chargings.map(charge => {
            return{
              chargingType:{id: charge.chargingType.id, name: charge.chargingType.name},
              minimumBookingPeriodAvailability:  charge.minimumBookingPeriodAvailability,
              acceptedHalfHourBooking: charge.acceptedHalfHourBooking,
              minimumBookingPeriod: charge.minimumBookingPeriod,
              discounts: charge.discounts?.map(discount => {return{
                amount: discount.amount,
                id: discount?.id =='5e7cb0aeaac4f142d8075f87' ? null:discount.id,
                term: discount.term
              }}),
              pricingOptions: getPricingOptionsForMeetTrain(charge.pricingOptions),
              packages: charge.packages
            }
          }) : eventsData ? spaceDetails.events[0]?.chargings.map(charge => {
            return{
              chargingType:{id: charge.chargingType.id, name: charge.chargingType.name},
              minimumBookingPeriodAvailability:  charge.minimumBookingPeriodAvailability,
              acceptedHalfHourBooking: charge.acceptedHalfHourBooking,
              minimumBookingPeriod: charge.minimumBookingPeriod,
              discounts: charge.discounts?.map(discount => {return{
                amount: discount.amount,
                id: discount?.id =='5e7cb0aeaac4f142d8075f87' ? null:discount.id,
                term: discount.term
              }}),
              pricingOptions: getPricingOptionsForMeetTrain(charge.pricingOptions),
              packages: charge.packages
            }
          }) : null,
          keepInMindMeet: spaceDetails.keepInMind ? spaceDetails.keepInMind?.map(k_mind => {return {
              rule: {
                id: k_mind.rule?.id
              },
              isDisabled: k_mind.isDisabled
            }
          }) : eventsData? spaceDetails.events[0]?.keepInMind?.map(k_mind => {return {
            rule: {
              id: k_mind.rule?.id
            },
            isDisabled: k_mind.isDisabled
          }
        }) : null,
          spaceAddOns: spaceDetails.spaceAddOns ? spaceDetails.spaceAddOns?.map(addOn => {return {
              isAvailable: true,
              id: addOn.addOn?.id,
              charge: {
                  price: addOn.charge?.price?.amount
              },
              description: addOn.description
          }}) : eventsData ? spaceDetails.events[0]?.spaceAddOns?.map(addOn => {return {
            isAvailable: true,
            id: addOn.addOn?.id,
            charge: {
                price: addOn.charge?.price?.amount
            },
            description: addOn.description
        }}) : null,
          // seatArrangements: spaceDetails.seatArrangements?.map(seat => {
          //   return{
          //     seatArrangement: seat.seatArrangement,
          //     min: seat.min,
          //   }
          // }),
          meetOrTrain: spaceDetails?.chargings ? setPricingOptionDays(spaceDetails.chargings) : eventsData?  setPricingOptionDays(spaceDetails.events[0]?.chargings) : null
        })
        setActivityId(spaceDetails.eventTypes ? spaceDetails.eventTypes[0].spaceCategory?.id : eventsData? spaceDetails.events[0].eventType.id : null);
      }

}

const getPricingOptionsForMeetTrain = (pricingOptions) => {
  if (pricingOptions){
    const pricingOptionObject = {};
    pricingOptions.forEach(option => {
      if(!pricingOptionObject[option.name]) pricingOptionObject[option.name] = [];
      pricingOptionObject[option.name] = [...pricingOptionObject[option.name], {
        startTime: option.startTime,
        endTime: option.endTime,
        pricePerHour: option.price.amount
      }]
    });
    return pricingOptionObject;
  }else{
    return null
  }
}


const setPricingOptionDays = (chargings) => {
    const hourly = chargings.filter(charge => charge.chargingType.name === 'Hourly').map(charge => charge.pricingOptions.map(pOption => pOption.name));
    const daily = chargings.filter(charge => charge.chargingType.name === 'Daily').map(charge => charge.pricingOptions.map(pOption => pOption.name));
    const block = chargings.filter(charge => charge.chargingType.name === 'Block').map(charge => charge.pricingOptions.map(pOption => pOption.name));
    return {
      hourlyPricingOption: {
        days:  hourly && hourly.length > 0 ?[...hourly[0].filter((item, index) => hourly[0].indexOf(item) === index)] : []
      },
      dailyPricingOption: {
        days: daily && daily.length > 0 ? [...daily[0].filter((item, index) => daily[0].indexOf(item) === index)] : []
      },
      blockOption: {
        days: block && block.length > 0 ? [...block[0].filter((item, index) => block[0].indexOf(item) === index)] : []
      },
    }
}

const getCurrencyByCountry = (country)=>{
  switch (country) {
    case 'LK':return 'LKR'
    break;
    case 'SG':return 'SGD'
    break;
    case 'AUS':return 'AUD'
    break;
  
    default: return 'N/A'
      break;
  }
}